import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HelperService } from '../../../services/helper.service';

import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';

import { ApiService } from '../../../services/api.service';

declare let $: any;
declare let bootbox: any;

@Component({
	selector: 'members-batchupload-page',
	templateUrl: './batchupload.html',
	styleUrls: ['./batchupload.css']
})
export class MembersBatchUploadPage {
	public modelName: string = 'member';
	public batchBtnStatus: boolean = true;
	public sendPwdBtnStatus: boolean = true;
	

	public form: FormGroup = this.formBuilder.group({
		// basic information
		file: ['',Validators.required],
		early_bird: [''],
		year: ['']
	});
	
	public constructor(
		private helper: HelperService,
		public formBuilder: FormBuilder,

		public data: DataService,
		public _form: FormService,

		private api: ApiService,
		private router: Router,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {}

	public ngOnInit() {
		if(!this.modelName) console.error('Missing modelName.');

		this._form.setForm(this.form);
		
		this.onBeforeRendered();
		
		
	}
	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

	}

	public onSubmit(): void {
		this.batchBtnStatus = false;
		let data = JSON.parse(JSON.stringify(this.form.value)); // copy

		//console.log(data);
		//return false;
		// stop from page
		if(data === false)
			return;

		if(this.form.valid) {
			try {
				let promise;
				promise = this.api.sendApiRequest('post', 'member/batchupload', data).toPromise();
				

				promise
				.then(res => {
					console.log(res);
					this.onAfterSubmit(true,res._body);
					this.batchBtnStatus = true;
				})
				.catch(err => {
					console.log(err);
					this.onAfterSubmit(false,err._body);
					this.batchBtnStatus = true;
				});
			}
			catch(e) {
				console.error(e);
					this.batchBtnStatus = true;
			}
		}
		else {
			this._form.showErrors();
			this.batchBtnStatus = true;
		}
	}
	public onAfterSubmit(success: boolean, msg: string): void {
		if(success) {
			bootbox.alert({
				message: msg,
				callback:() => {
					
				}
			});
		}
	};


}



// WEBPACK FOOTER //
// ./src/pages/members/batchupload/batchupload.ts